import { render, staticRenderFns } from "./socials-accordion.vue?vue&type=template&id=f5ab93fe&scoped=true&"
import script from "./socials-accordion.vue?vue&type=script&lang=js&"
export * from "./socials-accordion.vue?vue&type=script&lang=js&"
import style0 from "./socials-accordion.vue?vue&type=style&index=0&id=f5ab93fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ab93fe",
  null
  
)

/* custom blocks */
import block0 from "./socials-accordion.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports